export enum FUNCTION_NUMBER {
  frequencyMonitoringSettings = 1,
  islandDetectionSettings = 16384,
  lfsmOSettings = 16,
  lfsmUSettings = 1024,
  voltageMonitoringSettings = 2,
  dynamicGridPowerSettings = 2048,
  reactivePowerSettings = 4,
  activePowerSettings = 8,
  restartConditionsTimeSettings = 32,
  restartConditionsGradientSettings = 128,
  restartConditionsVoltageSettings = 256,
  restartConditionsFrequencySettings = 512,
  minCosPhiSettings = 64,
}

export enum REACTIVE_POWER_FULCRUM_FUNCTION_NUMBER {
  fixCosPhi = 1,
  cosPhi = 2,
  qU = 4,
  fixedQ = 8,
}

export enum ACTIVE_POWER_FULCRUM_FUNCTION_NUMBER {
  typeA = 1,
  typeB = 2,
}

export enum REACTIVE_POWER_FUNCTION_DTO {
  fixCosPhi = 'fixCosPhi',
  cosPhi = 'cosPhi',
  qU = 'qU',
  fixedQ = 'fixedQ',
}

export enum ACTIVE_POWER_FUNCTION_DTO {
  typeA = 'typeA',
  typeB = 'typeB',
}

export enum REACTIVE_POWER_FUNCTION_MODEL {
  fixCosPhi = 'cos φ(P) fix',
  cosPhi = 'cos φ(P)',
  qU = 'Q(U)',
  fixedQ = 'Q fix',
}

export enum ACTIVE_POWER_FUNCTION_MODEL {
  typeA = 'P(U) Type A',
  typeB = 'P(U) Type B',
  disabled = 'disabled',
}

export enum PHASE_SHIFT {
  inductive,
  capacitive,
}

export enum ISLAND_DETECTION_VALUE {
  passive,
  active,
}

export type FulcrumLimits = {
  x: { min: number; max: number; changed: boolean }
  y: { min: number; max: number; changed: boolean }
}

export type ValueWithLimits = {
  value: number | null
  min: number | null
  max: number | null
  changed: boolean
}

export type BooleanValueWithValidation = {
  isDisabled: boolean
  changed: boolean
}

export type FrequencyProtectionWithValidations = {
  frequency: ValueWithLimits
  timeSeconds: ValueWithLimits
}

export type VoltageProtectionWithValidations = {
  voltage: ValueWithLimits
  timeSeconds: ValueWithLimits
  largerVoltage: ValueWithLimits
  largerTimeSeconds: ValueWithLimits
}

export type DeadBandThresholdFieldWithValidations = {
  lower: ValueWithLimits
  upper: ValueWithLimits
}

export type ReactivePowerFixedFunctionWithValidations = {
  functionNumber: number
  value: ValueWithLimits
}

export type ReactivePowerFunctionWithValidations = {
  functionNumber: number
  values: [number, number][]
  limits: FulcrumLimits[]
  enabled?: boolean
}

export type ActivePowerFunctionWithValidations = {
  functionNumber: number
  values: [number, number][]
  limits: FulcrumLimits[]
  enabled?: boolean
}

export type FrequencyProtection = {
  frequency: number | null
  timeSeconds: number | null
}

export type VoltageProtection = {
  voltage: number | null
  timeSeconds: number | null
  largerVoltage: number | null
  largerTimeSeconds: number | null
}

export type DeadBandThresholdField = {
  lower: number | null
  upper: number | null
}
